import { useState } from 'react';

import { IFile, IUseFileLogoInput } from './types';

export function useFileLogoInput({ value, onChange }: IUseFileLogoInput) {
  //@ts-ignore
  const [imgSrc, setImgSrc] = useState<string>(typeof value === 'object' && value.url);
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);

  const handleChange = (file: IFile) => {
    setImgSrc(file?.url);
    setIsModalOpened(false);

    onChange(file);
  };

  const handleClearFile = () => {
    onChange();
    setImgSrc('');
  };

  const handleCloseModal = () => {
    setIsModalOpened(false);
  };

  const handleOpenModal = () => {
    setIsModalOpened(true);
  };

  return {
    imgSrc,
    isModalOpened,
    handleChange,
    handleClearFile,
    handleOpenModal,
    handleCloseModal,
  };
}
